import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  setFocus(anchor: string) {
    const el = document.getElementById(anchor);
    if (el) {
      // give Angular a tick to render if needed
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
  }
  constructor(
    private viewportScroller: ViewportScroller
  ) { }

  ngOnInit() {
  }

  //  setFocus(myInput: string) {
  //     const element = document.getElementById(myInput);
  //   if (element) {
  //     element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     this.viewportScroller.scrollToAnchor(myInput);
  //   }
  // }


}
